// Cari seçim dropdown'larında birbirine benzeyen cari'leri ayırt etmek için
// tek-satırlık etiket üretir.
//
// Format: "KOD - UNVAN | TELEFON | VD/TC (PB)"
// Örnek:
//   Tüzel: "CRI00001 - ABC Ltd | 0216 555 1234 | Kadıköy VD 1234567890 (TRY)"
//   Gerçek: "CRI00002 - Ahmet Yılmaz | 0532 111 2222 | 12345678901 (TRY)"

export function formatCariOption(a) {
  if (!a) return '';
  const parts = [];
  // Kod ve Unvan
  const kodUnvan = `${a.code || ''}${a.code && (a.title || a.name) ? ' - ' : ''}${a.title || a.name || ''}`.trim();
  if (kodUnvan) parts.push(kodUnvan);

  // Telefon
  const tel = a.phone || a.mobile;
  if (tel) parts.push(tel);

  // VD / TC
  if (a.identity_type === 'individual') {
    if (a.id_number) parts.push(a.id_number);
  } else {
    const vd = a.tax_office;
    const vn = a.tax_number;
    if (vd && vn) parts.push(`${vd} ${vn}`);
    else if (vd) parts.push(vd);
    else if (vn) parts.push(vn);
  }

  const main = parts.join(' | ');
  const cur = a.currency_code || 'TRY';
  return `${main} (${cur})`;
}
